import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartLeftStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm1-2.1a5.002 5.002 0 0 0 0-9.8v9.8ZM7 9v3.9A5.006 5.006 0 0 1 3.1 9H7ZM3.1 7A5.006 5.006 0 0 1 7 3.1V7H3.1Z"
    />
  </svg>
);
export default IconDrillingPartLeftStrokedSizeS;
